import React, { useRef } from 'react'
import { Box } from '..'
import { BoxSelect, DropdownList, Label, Input } from './styled'

type ValueProp = {
  title: string
  value: number | {[field: string]: any}
}

type StateProps = {
  placeholder: boolean,
  dropdownList: boolean,
  value?: ValueProp
}

type Props = {
  onSelect: (value: ValueProp) => void
  placeholder: string
  data: ValueProp[]
  defaultValue?: ValueProp
}

const UiSelect: React.FC<Props> = ({ data, placeholder, onSelect, defaultValue }: Props) => {
  const INITIAL_VALUES = {
    placeholder: false,
    dropdownList: false,
    value: defaultValue
  }
  const boxRef = useRef<HTMLDivElement>(null)
  const [state, setState] = React.useState<StateProps>(INITIAL_VALUES)

  const handleClickOutside = (event: MouseEvent) => {
    if (!boxRef?.current?.contains(event.target as Node)) {
      setState(prev => ({
        ...prev,
        dropdownList: INITIAL_VALUES.dropdownList,
        placeholder: INITIAL_VALUES.placeholder
      }))
    }
  }

  const handleClick = () => {
    setState(prev => ({
      ...prev,
      dropdownList: !prev.dropdownList,
      placeholder: !prev.placeholder
    }))
  }

  const handleSelectItem = (item: ValueProp) => {
    setState({
      dropdownList: INITIAL_VALUES.dropdownList,
      placeholder: INITIAL_VALUES.placeholder,
      value: item
    })

    onSelect(item)
  }

  React.useEffect(() => {
    if (state.dropdownList) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [state.dropdownList])

  return (
    <Box ref={boxRef} pos="relative">
      <Box pos="relative" onClick={handleClick}>
        <Input className="input">{state.value ? state.value.title : placeholder}</Input>
        <Label className={`input ${state.placeholder ? 'in' : ''}`}>{placeholder}</Label>
        <BoxSelect />
      </Box>
      <DropdownList className={state.placeholder ? '' : 'out'}>
        {data.map((item) => (
          <div key={JSON.stringify(item.value)} onClick={() => handleSelectItem(item)}>{item.title}</div>
        ))}
      </DropdownList>
    </Box>
  )
}

export default UiSelect
